export default {
  title: 'Funcții suplimentare pentru mai mult succes',
  description: 'Îmbunătățiți planul cu funcții suplimentare',
  buttons: {
    continue: 'Continuați',
    no_app_for_now: 'Fără aplicație mobilă deocamdată',
  },
  toasts: {
    something_went_wrong: 'Ceva a mers greșit, încercați să reîncărcați pagina sau contactați suportul tehnic!',
    failed_to_save_changes: 'Modificările nu au putut fi salvate, vă rugăm să contactați suportul tehnic!',
    changes_got_saved: 'Modificările au fost salvate cu succes!',
  },
};
